/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { safeHTML } from 'common/utils/safe-html';

import styles from '../styles.less';

const CommonSubFee = ({ label, value, subTitle }) => {
  if (label.length == 0 || value.length == 0) {
    return <div />;
  }

  return (
    <div className={styles.quote}>
      <span className={styles.gigworkerfeegroup}>
        {label}
        {subTitle.length !== 0 && (
          <small className={styles.smalldescription}>
            <span dangerouslySetInnerHTML={{ __html: safeHTML(subTitle) }} />
          </small>
        )}
      </span>
      <span className={styles.combinedPriceTag}>
        <span>{value}</span>
      </span>
    </div>
  );
};

CommonSubFee.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  subTitle: PropTypes.string,
};

CommonSubFee.defaultProps = {
  label: '',
  value: '',
  subTitle: '',
};

export default CommonSubFee;
